export default __webpack_public_path__ + "static/media/portfolio3.84f6cfbf.jpg";